import { SelectedBadgeRows } from "../../../../../../types";
import { useEffect, useState } from "react";
import { BadgePaymentStatus, BadgeStatuses } from "../../../../../../../../common/enums";
import BadgeHelper from "../../../../../../../../common/badges/helper/BadgeHelper";
import EventHelper from "../../../../../../../../common/network/helpers/event/EventHelper";
import { useUnpaidBadgePayment } from "../../../../../../../search/hooks/useUnpaidBadgePayment/useUnpaidBadgePayment";

type Props = {
  selectedRows: SelectedBadgeRows;
};

export const useTableToolbarSelect = ({ selectedRows }: Props) => {
  const [isDeactivationDisabled, setIsDeactivationDisabled] = useState(true);
  const [isPrintingDisabled, setIsPrintingDisabled] = useState(true);
  const [isEmailResendDisabled, setIsEmailResendDisabled] = useState(true);
  const [isMakePaymentDisabled, setMakePaymentDisabled] = useState(true);
  const { getUnpaidBadgeOrder } = useUnpaidBadgePayment({ selectedBadges: [] });

  const configureButtons = () => {
    const { badges } = selectedRows;
    const isEventWithPhotos = EventHelper.eventEdition?.isPhotoRequiredForAccess;
    const areAllBadgesWithPhotos = isEventWithPhotos ? badges.filter(badge => Boolean(badge.photoKey)).length === badges.length : true;
    const areAllBadgesActive = badges.filter(badge => badge.status === BadgeStatuses.ACTIVE).length === badges.length;
    const areAllBadgesPendingOrActive = badges.filter(badge => BadgeHelper.isBadgePending(badge.status) || BadgeHelper.isBadgeActive(badge.status)).length === badges.length;
    const areAllBadgesDeactivate = badges.filter(badge => BadgeHelper.isBadgeActive(badge.status)).length === badges.length;
    const areAllBadgesUnpaid = badges.filter(badge => badge.paymentStatus === BadgePaymentStatus.UNPAID).length === badges.length;
    const unpaidBadge = badges.find(badge => badge.paymentStatus === BadgePaymentStatus.UNPAID);

    const areAllUnpaidWithOrders = badges.filter(badge => getUnpaidBadgeOrder(badge).length === 1).length === badges.length;

    if (areAllBadgesUnpaid && areAllUnpaidWithOrders && areAllBadgesPendingOrActive) {
      setMakePaymentDisabled(false);
    }

    if (areAllBadgesDeactivate) {
      setIsDeactivationDisabled(false);
    }

    if (areAllBadgesActive && areAllBadgesWithPhotos) {
      setIsEmailResendDisabled(false);
    }

    if (areAllBadgesActive && !unpaidBadge && areAllBadgesWithPhotos) {
      setIsPrintingDisabled(false);
    }
  };

  useEffect(() => {
    configureButtons();
  }, [selectedRows.badges.length]);

  useEffect(() => {
    configureButtons();
  }, []);

  return { isDeactivationDisabled, isPrintingDisabled, isEmailResendDisabled, isMakePaymentDisabled };
};